import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventComponent } from './event.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { PipesModule } from '@shared-pipes/pipes.module';
import { DirectivesModule } from '@shared-directives/directives.module';
import { TranslationModule } from '@app/app-translation.module';
import {
	FormDateModule,
	FormInputModule,
	FormNumberModule,
	FormSelectModule,
	FormTextareaModule,
	FormColorModule,
	FormTimeModule,
	FormValidationErrorModule,
	FormLabelModule,
	FormRadioModule,
} from '@beego/ngx-form-components';

import { EventTypeComponentModule } from '@internal-components/administration-components/event-type-components/event-type-component/event-type.component.module';
import { TooltipModule } from '@make-lynxwork/ng2-tooltip-directive';
import { LocationComponentModule } from '@internal-components/administration-components/locations-components/location-component/location.component.module';
import { DigibankAgencyComponentModule } from '@internal-components/administration-components/digibank-agency-components/digibank-agency-component/question-category.component.module';
import { ModalComponentModule } from '@shared-components/modal-component/modal.component.module';
import { LessonComponentModule } from '../lesson-component/lesson.component.module';

@NgModule({
	declarations: [EventComponent],
	exports: [EventComponent],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		IonicModule,
		TranslationModule,
		PipesModule,
		DirectivesModule,
		FormInputModule,
		FormTextareaModule,
		FormSelectModule,
		FormDateModule,
		FormTimeModule,
		FormColorModule,
		FormLabelModule,
		FormRadioModule,
		FormValidationErrorModule,
		FormNumberModule,
		EventTypeComponentModule,
		LocationComponentModule,
		DigibankAgencyComponentModule,
		LessonComponentModule,
		TooltipModule,
		ModalComponentModule,
	],
	providers: [],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EventComponentModule {}
